import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick, useFacets } from '@nosto/preact'
import Products from './Products'
import Toolbar from './Toolbar'
import BottomToolbar from './BottomToolbar'
import SelectedFilters from './SelectedFilters'
import { wrapContent } from './ContentWrapper'
import Loader from './elements/Loader'
import NoResults from './NoResults'
import Sidebar from './Sidebar'

export function SerpBody({ loading, foundProducts }) {
    const { query, response, pageType } = useAppStateSelector((state) =>
        pick(state, 'loading', 'query', 'response', 'pageType')
    )
    const docCount = response.products?.total ?? 0

    if (loading) return <Loader />
    return foundProducts ? (
        <>
            <Sidebar />
            <div data-section-type="collection-template">
                {/* <p class="medium-up--hide text-center" data-scroll-to="">
                    {docCount} tuotetta
                </p> */}
                <Products />
                <BottomToolbar />
            </div>
        </>
    ) : (
        <NoResults />
    )
}

export default wrapContent('search', SerpBody)
